








import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../domain/drawing";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";

@Component
export default class SizeEditor extends Mixins(ModelEditableMixin, DisableableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: Size) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: Size) => T, defaultValue: T) => T;

  get width(): number {
    return this.readPropertyOrDefault(s => s.width, 0);
  }

  set width(value: number) {
    this.writePropertyWhenValid(s => s.width = value);
  }

  get height(): number {
    return this.readPropertyOrDefault(s => s.height, 0);
  }

  set height(value: number) {
    this.writePropertyWhenValid(s => s.height = value);
  }
}
